import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {transactionList} from '../../service/shipRequest';
import {Button} from "antd";
import {config, openNotice} from 'Utils';
import moment from "moment";


class TransactionQuery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            stockType: [
                {"text": "股份本部", "value": "股份本部"},
                {"text": "云南库存", "value": "云南库存"},
                {"text": "四川库存", "value": "四川库存"},
                {"text": "山东库存", "value": "山东库存"},
                {"text": "广东库存", "value": "广东库存"},
                {"text": "新疆库存", "value": "新疆库存"},
                {"text": "河北库存", "value": "河北库存"},
                {"text": "河南库存", "value": "河南库存"},
                {"text": "湖北库存", "value": "湖北库存"},
                {"text": "辽宁库存", "value": "辽宁库存"},
                {"text": "陕西库存", "value": "陕西库存"},
                {"text": "天毅行本部", "value": "天毅行本部"}],
            rows: [],
            total: 0,
            loading: false,
            btnLoading: false,
            searchObj: {
                itemNum: '',
                itemDesc: '',
                organizationName: '',
                bookedDateFrom: '',
                bookedDateTo: '',
                orderNumber: '',
                closeHomologous: '',
                p: 1,
                s: 10
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);

    };

    routeLeaveHook(nextLocation) {
    };

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    goView(url) {
        hashHistory.push(url);
    };

    getData() {
        const self = this;
        const {searchObj} = this.state;
        transactionList(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                bookedDateFrom: '',
                bookedDateTo: '',
                orderNumber: '',
                closeHomologous: '',
                p: 1,
                s: 10
            }
        }, () => {
            self.getData();
        })
    };

    advanceSubmit(form) {
        const self = this;
        if (!this.state.searchObj.bookedDateFrom || this.state.searchObj.bookedDateFrom == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.bookedDateTo || this.state.searchObj.bookedDateTo == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    bookedDateFrom: value.from,
                    bookedDateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value.trim()}})
        }
    };

    exportList() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/shipRequest/transactionListExp`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    render() {
        const {
            rows,
            total,
            loading,
            searchObj,
            stockType
        } = this.state;


        const advanceProps = {
            fileds: [
                {
                    name: 'orderTime',
                    label: '事务处理时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startBookDate || '',
                        end: searchObj.endBookDate || ''
                    },
                }, {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    defaultValue: searchObj.itemNum,
                    type: 'default'
                }, {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    defaultValue: searchObj.itemDesc,
                    type: 'default'
                },
                {
                    name: 'organizationName',
                    label: '库存组织',
                    text: '选择库存组织',
                    defaultValue: searchObj.organizationName,
                    type: 'select',
                    multiple: false,//支持多选
                    options: stockType
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    defaultValue: searchObj.orderNumber,
                    type: 'default'
                }, {
                    name: 'closeHomologous',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    defaultValue: searchObj.closeHomologous,
                    type: 'default'
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };


        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '托管单位',
                    dataIndex: 'salesUnitName'
                }, {
                    title: '库存组织',
                    dataIndex: 'organizationName'
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                }, {
                    title: '事务处理时间',
                    dataIndex: 'transactionDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                }, {
                    title: '事务处理数量',
                    dataIndex: 'transactionQuantity'
                }, {
                    title: '事务处理类型',
                    dataIndex: 'transactionType'
                }, {
                    title: '单据编号',
                    dataIndex: 'txnNumber'
                }, {
                    title: '子库存',
                    dataIndex: 'sourceSubinvCode'
                }, {
                    title: '订单号',
                    dataIndex: 'orderNumber'
                }, {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous'
                }
            ],
            rows
        };

        return <div className="dms-body">
            <DmsTab options={[`出入库查询`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div style={{marginBottom: 35}}>
                    <Button style={{position: 'absolute', right: 13}} icon="export"
                            onClick={this.exportList.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(TransactionQuery);


// WEBPACK FOOTER //
// ./src/routes/shipRequest/transactionQuery.js